const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { hamburger } = require("./modules/hamburger");
const { end } = require("./modules/end");

scrollmagic();
pageTop();
smooth();
hamburger();
// end();